import { render } from "./AcessorioResumo.vue?vue&type=template&id=4662c239&scoped=true"
import script from "./AcessorioResumo.vue?vue&type=script&lang=js"
export * from "./AcessorioResumo.vue?vue&type=script&lang=js"

import "./AcessorioResumo.vue?vue&type=style&index=0&id=4662c239&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4662c239"]])

export default __exports__